import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthorizationRequirement } from '@core/models/interface';
import { Observable, of } from 'rxjs';
import { AuthorizationService } from '@core/service/authorization.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivateChild {
  private authorizationService = inject(AuthorizationService);
  private router = inject(Router);

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const requirement = this.getRequirement(childRoute);

    if (this.authorizationService.hasAccess(requirement)) {
      return of(true);
    }

    return of(this.router.parseUrl(requirement?.redirectTo || '/authentication/page403'));
  }

  private getRequirement(route: ActivatedRouteSnapshot): AuthorizationRequirement | undefined {
    let current: ActivatedRouteSnapshot | null = route;
    let requirement: AuthorizationRequirement | undefined;

    while (current) {
      const data = current.data || {};
      requirement = data['auth'] || this.authorizationService.fromLegacyRoles(data['role']) || requirement;
      current = current.firstChild;
    }

    return requirement;
  }
}
